module.exports = __webpack_public_path__ + "static/media/kaspersky_track.8eb2f95a.png";